export interface User {
  connectedUser: {
    name: string;
    lastName: string;
  };
  login: string;
  timestamp?: Date;
  inUse: boolean;
}
